
    /**
     * API events
     *
     * This triggers Backbone.Wreqr events on a dedicated
     * channel. This expects the jQuery and Wreqr apis/interfaces.
     *
     * Events simply return the jqXHR object. In most cases this is
     * sufficient to know what was requested and what happened.
     *
     * Some types of HTTP responses have specific meaning within the
     * context of the Electric Imp API. This event framework makes
     * no attempt to do anything special, so it is up to the app
     * to make decisions.
     *
     * <https://electricimp.com/docs/buildapi/#buildbeta-error-reporting>
     *
     * Usage:
     *
     *    // import this module
     *    var events = require('lib/api/events');
     *    // Set the channel to report api events on.
     *    // Without this step, none of the events will fire.
     *    events.channel = Radio.channel('api');
     *
     *    // Elsewhere, listening
     *    events.channel.on('error', function my_error_handler(jqXHR) { etc. });
     */
    /**
     * Triggered before the ajax request is initiated. The
     * jQuery API allows modification of the settings via the
     * beforeSend call. If you need to modify the settings for
     * an individual call, do it directly rather than this event.
     */
    function beforeSend(jqXHR) {
        if (!events.channel) return;
        events.channel.trigger('start', jqXHR);
    }
    /**
     * Triggered when the request has completed with a 2xx or 3xx status code
     */
    function success(data, textStatus, jqXHR) {
        if (!events.channel) return;
        events.channel.trigger('success', jqXHR);
    }
    /**
     * Triggered when the request has completed with a 4xx or 5xx status code
     */
    function error(jqXHR) {
        if (!events.channel) return;
        events.channel.trigger('error', jqXHR);
    }
    /**
     * Triggered at the end of a request, regardless of outcome
     */
    function complete(jqXHR) {
        if (!events.channel) return;
        events.channel.trigger('complete', jqXHR);
    }
    /**
     * Unauthorized access	401
     * Resource not found	404
     * Endpoint rate-limited	429
     * Unexpected internal error	500
     * Other errors	400
     */
    var status_codes = {};
    ['400', '401', '404', '429', '500'].forEach(function(code){
        status_codes[code] = function(jqXHR) {
            if (!events.channel) return;
            events.channel.trigger(code, jqXHR);
        };
    });
    /**
     * NOTE: no individual 'success' codes are added here. They could be
     * but until the 'success' event fails to be sufficient, they're omitted.
     */
    var events = {
        channel: null,
        events: {
            beforeSend: beforeSend,
            success: success,
            error: error,
            complete: complete
        },
        statusCode: status_codes
    };
    export default events;

